export const state = () => ({
  city: null,
  showLoading:false,
  settings: null,
  main_settings: null,
  menus: [],
  drawerState: false,
  cart: {
    items: [],
    totalCount: 0,
    totalPrice: 0,
    totalDiscount: 0,
    billPrice: 0,
  },
});

export const getters = {
  getCity: (state) => {
    return state.city
  },
  getSettings: (state) => {
    return state.settings
  },
  getMainSettings: (state) => {
    return state.main_settings
  },
  getMenus: (state) => {
    return state.menus
  },
  drawerState: (state) => state.drawerState

}

export const mutations = {
  setCity(state, data) {
    state.city = data;
},
  setShowLoading(state, data) {
    state.showLoading = data;
},
  toggleDrawerState (state, data) {
      state.drawerState = data
    },
  setSettings(state, data) {
    state.settings = data;
  },
  setMainSettings(state, data) {
    state.main_settings = data;
  },
  setMenus(state, data) {
    state.menus = data;
  },
  setCartItems(state, data) {
    state.cart.items = data;
  },
  setCartTotalPrice(state, data) {
    state.cart.totalPrice = data;
  },
  increaseCartTotalPrice(state, data) {
    state.cart.totalPrice = parseInt(state.cart.totalPrice) + parseInt(data);
  },
  decreaseCartTotalPrice(state, data) {
    state.cart.totalPrice = parseInt(state.cart.totalPrice) - parseInt(data);
  },
}

export const actions = {
  async addToCart({ commit, state , rootState }, data) {
    if(rootState.auth.loggedIn == true) await this.$axios.$post('cart/add', { variety_id: data });
    console.log('THIS IS IT :::::: ');
    console.log(state.cart.items);
    let temp = JSON.parse(JSON.stringify(state.cart.items));
    if (temp.some(e => e.id == data)) {
      /* vendors contains the element we're looking for */
      temp.find(x => x.id == data).quantity++;
      commit('increaseCartTotalPrice',temp.find(x => x.id == data).price);
    } else {
      let variety = await this.$axios.$get('product-varieties/' + data);
      variety["quantity"] = 1;
      temp.push(variety);
      commit('increaseCartTotalPrice',variety.price);
    }
    commit('setCartItems', temp);
  },
  async removeFromCart({ commit, state , rootState }, data) {
    if(rootState.auth.loggedIn == true) await this.$axios.$post('cart/remove', { variety_id: data });
    let temp = JSON.parse(JSON.stringify(state.cart.items));

    if (temp.some(e => e.id == data)) {
      /* vendors contains the element we're looking for */
      temp.find(x => x.id == data).quantity--;
      commit('decreaseCartTotalPrice',temp.find(x => x.id == data).price);
      if (temp.some(e => e.quantity == 0)) {
        temp = temp.filter(x => {
          return x.id != data;
        })
      }
    }
    commit('setCartItems', temp);
  },
  async retrieveCart({ commit,rootState}, data) {
    if (rootState.auth.loggedIn == true) {
      let cart = await this.$axios.$get('cart');
      commit('setCartItems', cart.items);
      commit('setCartTotalPrice', cart.totalPrice);
    }
  },
  async retrieveSettings({ commit,rootState}, data) {
    let settings = await this.$axios.$get('setting').then((response)=>response.data);
    commit('setSettings', settings.site);
    commit('setMainSettings', settings.main);

  },
  async retrieveMenus({ commit,rootState}, data) {
    let menus = await this.$axios.get("ad-categories",{params:{'format': 'nested'}}).then((res) => res.data);
    commit('setMenus', menus);
  },
}
